import React from 'react';
import useAuthGuard from '../hooks/useAuthGuard';
import Layout from '../components/Layout';

function PackageDetail() {
    useAuthGuard();

    return (
        <Layout>

            Package

        </Layout>
    );
}

export default PackageDetail;
